// PasswordConfirmField.jsx
import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { matchesField } from 'revalidate';
import { FiEye, FiEyeOff } from 'react-icons/fi'; // Iconos de ojo

const PasswordConfirmField = ({ name, placeholder, maxLength }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Field
            name={name}
            validate={matchesField("password")({ message: "La contraseña no coincide" })}
        >
            {({ input, meta }) => (
                <div style={{ marginBottom: 16, position: 'relative' }}>
                    <input
                        {...input}
                        placeholder={placeholder}
                        type={showPassword ? 'text' : 'password'}
                        maxLength={maxLength}
                        style={{
                            width: '100%',
                            padding: '10px 40px 10px 10px', // espacio para el icono
                            fontSize: 16,
                            borderRadius: 6,
                            border: meta.touched && meta.error ? '1px solid red' : '1px solid #ccc',
                        }}
                    />

                    {/* Icono fijo */}
                    <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: '24px',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#666',
                        }}
                    >
                        {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                    </span>

                    {meta.touched && meta.error ? (
                        <div className="ui red pointing basic label">{meta.error}</div>
                    ) : null}
                </div>
            )}
        </Field>
    );
};

export default PasswordConfirmField;
